<mat-form-field class="dynamicForm_alignment">
  <input [ngxTimepicker]="defaultValue" [(ngModel)]="ngModelValue" [placeholder]="field.labelName" matInput
    readonly [required]="isRequired">
    <ngx-material-timepicker #defaultValue (timeSet)="updateValue($event)"></ngx-material-timepicker><br>
    @if (group.get(formValue).hasError(required)) {
      <mat-error>Time selection is required</mat-error>
    }
  </mat-form-field>